import { Toaster as Sonner, type ToasterProps } from "sonner"
import { buttonVariants } from "~/components/ui/button"

const Toaster = ({ ...props }: ToasterProps) => {
	return (
		<Sonner
			toastOptions={{
				unstyled: true,
				classNames: {
					toast: "orbit-toast",
					success: "orbit-toast-success",
					error: "orbit-toast-error",
					warning: "orbit-toast-warning",
					info: "orbit-toast-info",
					loading: "orbit-toast-loading",
					title: "orbit-toast-title",
					description: "orbit-toast-description",
					icon: "orbit-toast-icon",
					content: "orbit-toast-content",
					actionButton: "orbit-toast-action",
					cancelButton: "orbit-toast-cancel",
					closeButton: buttonVariants({
						variant: "ghost",
						size: "icon-xs",
						className: "absolute right-2 top-2"
					})
				}
			}}
			{...props}
		/>
	)
}

export { Toaster }
